<div class="text-align-center m-5">


    <h3>You have canceled the payment.</h3>
    <p-button (click)="checkout()">
        Checkout
    </p-button>
</div>